/**
 * @module ol/CollectionEventType
 */
/**
 * @enum {string}
 */
export default {
    /**
     * Triggered when an item is added to the collection.
     * @event module:ol/Collection.CollectionEvent#add
     * @api
     */
    ADD: 'add',
    /**
     * Triggered when an item is removed from the collection.
     * @event module:ol/Collection.CollectionEvent#remove
     * @api
     */
    REMOVE: 'remove',
};
//# sourceMappingURL=CollectionEventType.js.map